import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'
// import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'

const { defaults } = themeColorSectionKeys

export const inputStyleParts = ['field'] as const

const helpers = createMultiStyleConfigHelpers(inputStyleParts)
export const InputStyle = helpers.defineMultiStyleConfig({
  variants: {
    mango: {
      field: {
        backgroundColor: defaults.Input.Background.Default,
        color: defaults.FontColor.Default,
        border: '1px solid',
        borderColor: defaults.Input.Border.Default,
        borderRadius: '0.5rem',
        paddingX: '0.75rem',
        opacity: 1,
        outline: 'none',
        textStyle: textStyleKeys.Body1,
        fontSize: textStyles.Body1.fontSize,
        _placeholder: {
          color: defaults.FontColor.Placeholder,
          textStyle: textStyleKeys.Body1,
        },
        _hover: {
          backgroundColor: defaults.Input.Background.Hover,
          borderColor: defaults.Input.Border.Hover,
        },
        _active: {
          backgroundColor: defaults.Input.Background.Active,
        },
        _focus: {
          backgroundColor: defaults.Input.Background.Focus,
          borderColor: defaults.Input.Border.Focus,
          boxShadow: `${asChakraVariable(
            defaults.Input.BoxShadow.Focus,
          )} 0px 4px 8px 0px`,
        },
        _invalid: {
          borderColor: defaults.Input.Border.Error,
        },
        _disabled: {
          opacity: 'none',
          borderColor: defaults.Input.Border.Disabled,
          backgroundColor: defaults.Input.Background.Disabled,
          color: defaults.Input.FontColor.Disabled,
          _hover: {
            borderColor: defaults.Input.Border.Disabled,
            backgroundColor: defaults.Input.Background.Disabled,
          },
        },
      },
    },
    webPhoneModal: {},
  },
  defaultProps: {
    variant: 'mango',
  },
})
